import React, { type ReactNode } from 'react';

import { useFocus } from '../../hooks/use-focus';

export type FieldsetHeadlessProps = {
  id: string;
  ariaLabelledBy: string;
  ariaDescribedBy?: string;
  required?: boolean;
  className?: string;
  children: ReactNode;
  onBlur?: React.FocusEventHandler<HTMLFieldSetElement>;
  onFocus?: React.FocusEventHandler<HTMLFieldSetElement>;
};

export const FieldsetHeadless = ({
  id,
  ariaLabelledBy,
  ariaDescribedBy,
  required,
  className,
  onBlur,
  onFocus,
  children,
}: FieldsetHeadlessProps) => {
  const { handleFocus, handleBlur, containerRef } =
    useFocus<HTMLFieldSetElement>({
      onBlur,
      onFocus,
    });

  return (
    <fieldset
      ref={containerRef}
      id={id}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      aria-required={required}
      className={className}
      onBlur={handleBlur}
      onFocus={handleFocus}
    >
      {children}
    </fieldset>
  );
};
